import AdminMenu from '../../components/AdminMenu'
import AdminTopMenu from '../../components/AdminTopMenu'
import AdminTurmaCard from '../../components/AdminTurmaCard'

import * as S from './styles'

const AdminTurmas = () => {
  return (
    <>
      <S.bgAdmin>
        <AdminTopMenu title="Turmas" />
        <AdminMenu />
        {/* No momento não é interessante uma barra de pesquisa,
        mas optei por deixar comentado, caso pretenda implementar futuramente */}

        {/* <div className="input-group mt-3 mb-3">
          <span className="input-group-text">Pesquisar</span>
          <div className="form-floating">
          <input
          type="email"
          className="form-control"
          id="floatingInput"
          placeholder="name@example.com"
          />
          <label htmlFor="floatingInput">Nome da turma</label>
          </div>
          </div> */}
        <div className="col-12 col-md-7 col-lg-5 d-flex flex-column justify-center mx-auto">
          <AdminTurmaCard />
        </div>
      </S.bgAdmin>
    </>
  )
}

export default AdminTurmas
